<template>
  <router-link class="nav-item is-tab" :to="to">
    <slot></slot>
  </router-link>
</template>


<script>
export default {
  name: 'nav-bar-item',
  props: {
    to: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/_variables.scss';

a.nav-item:hover {
  color: $primary
}

.nav-item a,
a.nav-item {
  color: $primary
}

.router-link-active {

}
</style>




// WEBPACK FOOTER //
// NavBarItem.vue?51cb1da5